import { transformColor } from '@amityeko/pbc-core/dist/utilities/color';
export function generateSelectionColors(baseColor) {
    if (!baseColor)
        return {};
    return {
        '--private-selected-color': baseColor,
        '--private-selected-bg-color': transformColor(baseColor, 7, 1),
        '--private-selected-hover-color': transformColor(baseColor, 7, 2),
        '--private-selected-active-color': transformColor(baseColor, 7, 3),
    };
}
//# sourceMappingURL=helpers.js.map